<p-card
	[header]="controller.baseI18 + 'notifications' | translate"
	styleClass="h-full"
>
	<div [formGroup]="form" class="space-y-3 flex flex-col h-full">
		<div class="flex flex-col space-y-1 items-stretch">
			<label>
				{{ controller.baseI18 + 'moodFrequency.label' | translate }}
			</label>
			<p-dropdown
				[options]="controller.frequencyOptions$ | async"
				[placeholder]="controller.baseI18 + 'moodFrequency.placeHolder' | translate"
				formControlName="moodFrequency"
				styleClass="w-full"
			></p-dropdown>
		</div>
		<div class="flex space-x-1 items-center">
			<p-checkbox [binary]="true" formControlName="notifyInactivity"></p-checkbox>
			<label>
				{{ controller.baseI18 + 'inactivityNotification.label' | translate }}
			</label>
		</div>
		<div class="flex space-x-1 items-center">
			<p-checkbox [binary]="true" formControlName="notifyUnfinished"></p-checkbox>
			<label>
				{{ controller.baseI18 + 'unfinishedNotification.label' | translate }}
			</label>
		</div>
		<div class="flex space-x-1 items-center">
			<p-checkbox
				[binary]="true"
				formControlName="notifyWeeklyReport"
			></p-checkbox>
			<label>
				{{ controller.baseI18 + 'weeklyNotification.label' | translate }}
			</label>
		</div>
		<div class="flex space-x-1 items-center">
			<p-checkbox [binary]="true" formControlName="notifyNewsletter"></p-checkbox>
			<label>
				{{ controller.baseI18 + 'newsletterNotification.label' | translate }}
			</label>
		</div>
		<div class="flex flex-1 items-end justify-end">
			<p-progressSpinner
				*ngIf="controller.isSavingNotifications$ | async; else save"
				[style]="{ width: '25px', height: '25px' }"
			></p-progressSpinner>
			<ng-template #save>
				<button
					[disabled]="controller.notificationsFormInvalid$ | async"
					[label]="controller.baseI18 + 'save.label' | translate"
					(click)="onSaveClick()"
					pButton
				></button>
			</ng-template>
		</div>
	</div>
</p-card>
